import React, { Component } from "react";
import "./Accomodations.css";
import { AccomodationsItem } from "./AccomodationsItem";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import { getImgUrl, limitText } from "../../Utility/Utility";
import { AccomodationsData } from "../../Data/Data";

class Accomodations extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();

    this.AccomodationsSliderSettings = {
      dots: false,
      infinite: true,
      cssEase: "linear",
      autoplay: false,
      lazyLoad: "ondemand",
      arrows: true,
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      // slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "40px",
          },
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "30px",
          },
        },
      ],
    };
  }

  render() {
    const data = [...AccomodationsData];
    const postsHtml = data.map((o, i) => {
      // console.log("o:", o);
      return (
        <AccomodationsItem
          desc={o.desc}
          href={o.href}
          imgVideo={o.imgVideo}
          vidId={o.vidId}
          id={i}
          key={i}
        />
      );
    });
    return (
      <div className="wrapper-Accomodations">
        <SimpleSlider settings={this.AccomodationsSliderSettings}>
          {postsHtml}
        </SimpleSlider>

        {/* {postsHtml} */}
      </div>
    );
  }
}

export default Accomodations;



// WEBPACK FOOTER //
// ./src/Components/Accomodations/Accomodations.js